import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { getEditorViewStateMessageContent } from '../selectors/getStoreProperties';

/**
 * Utility function to get internal message
 * @returns internal message from store
 */
export default function getInternalMessage() {
    let isEnterpriseUser = !isConsumer();
    if (isEnterpriseUser) {
        return getEditorViewStateMessageContent();
    } else {
        return null;
    }
}
